import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { Pagination, PageHeader, paginate } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { LabourChecklistReportSchema } from "../LabourChecklistReportSchema";
import { HalfNameMarkReportTableContent } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import CreatePdf from './createPdf';
import ReactToPrint from "react-to-print";
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Card from '@material-ui/core/Card';
import _ from 'lodash';

const screenCode = 'LABOURCHECKLISTREPORT'

export function LabourChecklistReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [subNames, setSubNames] = useState([]);
    const [colName, setColName] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "",
        operationEntityID: "",
        collectionPointID: "",
        date: ""
    });
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        operationEntity: "",
        collectionPoint: ""
    });
    const [summeryValues, setSummeryValues] = useState({
        full: 0,
        half: 0,
        allTotal: 0
    });
    const [errors, setErrors] = useState({});
    const schema = Joi.object(LabourChecklistReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["employeeName", "registrationNumber", "cardNumber", "totalWeight", "reason", "lastWeighTime"]

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [data, setdata] = useState([]);
    const [summeryData, setSummeryData] = useState([]);
    const [csvData, setCsvData] = useState([]);
    const DropdownChanges = Object.freeze({ "group": 1, "operationEntity": 2 })
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    useEffect(() => {
        trackPromise(
            getPermissions()
        )
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
        resetDropDowns(DropdownChanges.group);
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
        getCollectionPointsForDropDown();
        resetDropDowns(DropdownChanges.operationEntity);
    }, [searchData.operationEntityID])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWLABOURCHECKLISTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        getGroupsForDropDown();
    }

    function resetDropDowns(type) {
        if (type === DropdownChanges.operationEntity) {
            setsearchData({
                ...searchData,
                collectionPointID: "0",
            });
        } else if (type === DropdownChanges.group) {
            setsearchData({
                ...searchData,
                operationEntityID: "0",
                collectionPointID: "0",
            });
        }
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;
        const error = { ...errors };
        const errorMessage = validateProperty(target, LabourChecklistReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        });

        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;
        let result = await service.getReportData(searchData.collectionPointID, searchData.date);
        formatResult(result);
        getSelectedDropdownValuesForReport(searchData);

    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var names = [];
        var csvHeaders = [
            { label: "Reg Number", value: "registrationNumber" },
            { label: "Employee Name", value: "firstName" }
        ];
        data.forEach(x => {

            var sessionName = x.sessionName;

            if (result.length === 0) {
                result.push({
                    [sessionName + 'N']: checkUndifind(x.totalAmount),
                    [sessionName + 'F']: x.fieldName,
                    employeeID: parseInt(x.employeeID),
                    registrationNumber: x.registrationNumber,
                    firstName: x.firstName,
                    total: checkUndifind(x.totalAmount),
                    configurationValue: x.configurationValue
                });
                names.push(x.sessionName);
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
            } else {
                totalOfAllrecords = totalOfAllrecords + parseFloat(x.totalAmount);
                var duplicate = result.find(y => parseInt(y.employeeID) == parseInt(x.employeeID));

                var duplicateName = names.find(y => y === x.sessionName);

                if (!duplicateName) {
                    names.push(x.sessionName);
                }

                if (duplicate) {
                    duplicate[sessionName + 'N'] = checkUndifind(duplicate[sessionName + 'N']) + checkUndifind(x.totalAmount);
                    duplicate[sessionName + 'F'] = x.fieldName;
                    duplicate.registrationNumber = x.registrationNumber;
                    duplicate.firstName = x.firstName;
                    duplicate.configurationValue = x.configurationValue;
                    duplicate.total = checkUndifind(duplicate.total) + checkUndifind(x.totalAmount);
                } else {
                    result.push({
                        [sessionName + 'N']: checkUndifind(x.totalAmount),
                        [sessionName + 'F']: x.fieldName,
                        employeeID: parseInt(x.employeeID),
                        registrationNumber: x.registrationNumber,
                        firstName: x.firstName,
                        total: checkUndifind(x.totalAmount),
                        configurationValue: x.configurationValue
                    });
                }
            }
        });
        var subNames = [];
        var subNamesCopy = [];
        for (let index = 0; index < names.length; index++) {
            subNames.push('Session ' + (index + 1) + 'N');
            subNames.push('Session ' + (index + 1) + 'F');
            csvHeaders.push({ label: "Session " + (index + 1) + ' Kg', value: "Session " + (index + 1) + 'N' });
            csvHeaders.push({ label: "Session " + (index + 1) + ' Field', value: "Session " + (index + 1) + 'F' });
            subNamesCopy.push('Session ' + (index + 1));
        }
        csvHeaders.push({ label: "Total", value: "total" });
        csvHeaders.push({ label: "Duration", value: "duration" });


        var result2 = [];

        result.forEach(x => {
            subNames.forEach(y => {
                if (x[y]) {
                    var res = y.slice(-1);
                    if (res == 'N') {
                        result2.push({
                            property: y,
                            value: checkUndifind(x[y])
                        });
                    }
                }
            });
        });

        const result3 = result2.reduce((obj, el) => {

            obj[el.property] = (obj[el.property] || 0) + el.value;

            return obj;
        }, {});
        const result4 = result.filter(x => x.total >= x.configurationValue);

        setSummeryValues({
            ...summeryValues,
            full: result4.length,
            half: result.length - result4.length,
            allTotal: totalOfAllrecords
        });

        setCsvHeaders(csvHeaders);
        setSubNames(subNames);
        setdata(result);
        setCsvData(result);
        setColName(subNamesCopy);

        var resultqqqq = Object.entries(result3);

        var temlArry = [];
        for (const key in resultqqqq) {
            temlArry.push({
                name: resultqqqq[key][0],
                value: resultqqqq[key][1]
            })
        }
        setSummeryData(temlArry);

    }

    function checkUndifind(value) {
        if (value === undefined) {
            return 0;
        }
        else {
            return value;
        }
    }

    function createFile() {
        var settings = {
            sheetName: 'Labour Checklist Report',
            fileName: 'LabourChecklistReport',
            writeOptions: {}
        }
        csvData.forEach(x => {
            x.duration = x.total >= x.configurationValue ? 'Full' : 'Half'
        });

        var copyOfCsv = _.cloneDeep(csvData)
        var newRow1 = {
            registrationNumber: "Group :" + groups[searchData.groupID],
            firstName: "Operation Entity : " + operationEntity[searchData.operationEntityID],
        }
        var newRow2 = {
            registrationNumber: "Collection Point :" + collectionPoint[searchData.collectionPointID],
            firstName: "Date : " + searchData.date,
        }
        var newRow3 = {
            registrationNumber: "Generated date/time : " + new Date().toLocaleString(),
            firstName: "Generated user : " + tokenService.getUserNameFromToken(),
        }

        var newRow4 = {
            registrationNumber: "Full : " + summeryValues.full,
            firstName: "Half : " + summeryValues.half,
        }
        var newRow5 = {
            registrationNumber: "Total  : " + summeryValues.allTotal,
        }

        copyOfCsv.push({}, newRow4, newRow5, {}, newRow1, newRow2, newRow3)

        xlsx(csvHeaders, copyOfCsv, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionPoint: collectionPoint[searchForm.collectionPointID],
            date: searchForm.date
        })
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function onCancelClick() {
        setsearchData({
            ...searchData,
            collectionPointID: "0",
        });

        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setdata([]);
        setIsTableHide(true);
        setSelectedSearchValues([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div className="card-body" id="startPoint">
                        <div className="row">
                            <PageHeader
                                title="Labour Checklist Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form>
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="searchDate">Date *</InputLabel>
                                    <TextField
                                        fullWidth
                                        id="date"
                                        name="date"
                                        type="date"
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                    {errors["searchDate"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["searchDate"]}</FormHelperText>)}
                                </div>
                            </div>
                            <div className="form-group row">
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </div>
                        </form>
                        {data.length != 0 ?
                            <Card>
                                <TableContainer component={Paper}>
                                    <div className="row alternative_cls bg-light  ">
                                        {summeryData.map((item) => (
                                            <div style={{ marginLeft: '15px' }} className="card-body width1"><p><b><p />{item.name.substring(0, item.name.length - 1)} Total :</b> {parseFloat(item.value).toFixed(2)} </p> </div>
                                        ))}
                                        <div className="card-body width1"><p><b><p />Total :</b> {parseFloat(summeryValues.allTotal).toFixed(2)}</p> </div>
                                        <div className="card-body width1"><p><b><p />Full :</b> {summeryValues.full} </p> </div>
                                        <div className="card-body width1"><p><b><p />Half : </b>{summeryValues.half}</p> </div>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                        Reg No
                                                    </TableCell>
                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                        Employee Name
                                                    </TableCell>
                                                    {colName.map((item) => (
                                                        <TableCell colSpan={2} style={{ fontWeight: "bold" }} align='center'>
                                                            {item}
                                                        </TableCell>
                                                    ))}
                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                        Total
                                                    </TableCell>
                                                    <TableCell rowSpan={2} align="center" style={{ fontWeight: "bold" }}>
                                                        Duration
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    {subNames.map((item) => {
                                                        var res = item.slice(-1);
                                                        return (
                                                            <TableCell style={{ fontWeight: "bold" }} align='right'>{res == 'N' ? 'Kg' : 'Field'}</TableCell>
                                                        );
                                                    })}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {data.map((row) => (
                                                    <TableRow key={row.registrationNumber}>
                                                        <TableCell component="th" align="left" >
                                                            {row.registrationNumber}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.firstName}
                                                        </TableCell>
                                                        {subNames.map((column) => {
                                                            const value = row[column];
                                                            var res = column.slice(-1);
                                                            return (
                                                                <TableCell align='right'>{value == undefined ? '-' : res == 'N' ? parseFloat(value).toFixed(2) : value}</TableCell>
                                                            );
                                                        })}
                                                        <TableCell align="center">{parseFloat(row.total).toFixed(2)}</TableCell>
                                                        <TableCell align="center">{row.total >= row.configurationValue ? 'Full' : 'Half'}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                </TableContainer>
                            </Card>
                            : null}
                    </div>
                    {data.length != 0 ?
                        <div className="pt-2">
                            <ReactToPrint
                                documentTitle={"Labour Checklist Report"}
                                trigger={() => <input
                                    type="button"
                                    className="btn btn-primary pull-right ml-2"
                                    value="PDF"

                                />}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePdf ref={componentRef} searchData={selectedSearchValues} contentRowNames={subNames} data={data}
                                    initialData={colName} summeryValues={summeryValues} summeryData={summeryData}
                                />
                            </div>
                            <input
                                type="button"
                                className="btn btn-primary pull-right ml-2"
                                value="Excel"
                                onClick={createFile}
                            />

                        </div>
                        : null}
                </div>
            </div>
        </Fragment >
    );
}



